module.exports = __webpack_public_path__ + "static/img/5-01.34f620e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/5-01.png
// module id = 178
// module chunks = 1